import { FilterFormFieldStrategyType } from "@/common/types";
import biaAccessTechOptions from "../filter-options/biaAccessTech.options";
import biaInterfaceTypeOptions from "../filter-options/biaInterfaceType.options";

const biaFiltersByProduct: FilterFormFieldStrategyType[] = [
  {
    key: "BandWidth",
    element: {
      inputType: "range",
      label: "BandWidth",
      required: false,
      name: "BIA-bandWidth",
      rangeMax: 10000,
      rangeMin: 0,
    },
  },
  {
    key: "Access Technology",
    element: {
      inputType: "checkboxGroup",
      label: "Access Technology",
      required: false,
      name: "BIA-AccessTechnology",
      rangeMax: 10000,
      rangeMin: 0,
      options: biaAccessTechOptions,
    },
  },
  {
    key: "Interface",
    element: {
      inputType: "checkboxGroup",
      label: "Interface",
      name: "BIA-interface",
      required: false,
      options: biaInterfaceTypeOptions,
    },
  },
];
export default biaFiltersByProduct;
